import * as React from 'react';
import { cn } from '../../../utils/cn';

type LabelProps = {
    label: string;
    htmlFor?: string;
    className?: string;
    isRequired?: boolean;
}

const Label = (props: LabelProps) => {
  const { label, htmlFor, className, isRequired } = props;

  const joinedClassName = cn('form-label', className, isRequired && 'required');
  return (
    <label htmlFor={htmlFor} className={joinedClassName}>
      {label}
    </label>
  );
};

export { Label };